/* Light/dark mode persistence for App Studio — shared by the shell and the
 * AppsList entry screen so portaled dialogs read the same mode everywhere. */

export const MODE_KEY = 'aps-mode';

export type ApsMode = 'light' | 'dark';

export function readStoredMode(): ApsMode {
    try {
        return localStorage.getItem(MODE_KEY) === 'dark' ? 'dark' : 'light';
    } catch {
        return 'light';
    }
}

export function storeMode(mode: ApsMode): void {
    try {
        localStorage.setItem(MODE_KEY, mode);
    } catch { /* ignore */ }
}
